import { render } from "./YogaGame.vue?vue&type=template&id=3518bdd6&scoped=true&ts=true"
import script from "./YogaGame.vue?vue&type=script&lang=ts"
export * from "./YogaGame.vue?vue&type=script&lang=ts"

import "./YogaGame.vue?vue&type=style&index=0&id=3518bdd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3518bdd6"]])

export default __exports__